const setOverflowShadows = el => {
  const SCROLL_THRESHOLD = 20;
  const scrolledToStart = Math.abs(el.scrollLeft) <= SCROLL_THRESHOLD;
  const scrolledToEnd = Math.abs(el.scrollLeft + el.clientWidth - el.scrollWidth) <= SCROLL_THRESHOLD;
  if (scrolledToStart) {
    el.classList.remove('overflow-shadow-left');
  } else {
    el.classList.add('overflow-shadow-left');
  }
  if (scrolledToEnd) {
    el.classList.remove('overflow-shadow-right');
  } else {
    el.classList.add('overflow-shadow-right');
  }
};

const isTouchDevice = () => {
  return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
}

const initHorizontalScroll = (el, { hideScrollBar, desktopSwipe }) => {
  el.classList.add('hidden');
  el.classList.add('hello-horizontal-scroll');
  el.addEventListener('scroll', () => {
    setOverflowShadows(el);
  });

  if (hideScrollBar) {
    el.classList.add('hello-horizontal-scroll--hide-scrollbar');
  }
  if (desktopSwipe) {
    // scrollbar is hidden, add swipe support for desktop
    if (!isTouchDevice()) {
      el.classList.add('hello-horizontal-scroll--desktop-swipe');
      let isHovering = false;
      let isDragging = false;
      const scrollVerticalToHorizontal = (event) => {
        if (isHovering) {
          el.scrollLeft += event.deltaY;
          setOverflowShadows(el);
        }
      }
      const scrollOnDrag = (event) => {
        if (isDragging && isHovering) {
          el.scrollLeft -= event.movementX;
          setOverflowShadows(el);
        }
      }
      el.addEventListener("pointerenter", () => isHovering = true);
      el.addEventListener("pointerdown", () => isDragging = true);
      el.addEventListener("pointerup", () => isDragging = false);
      el.addEventListener("pointerleave", () => { isDragging = false; isHovering = false; });
      el.addEventListener("pointermove", scrollOnDrag);
      el.addEventListener("wheel", scrollVerticalToHorizontal);
    }
  }
  el.classList.remove('hidden');
  setOverflowShadows(el);
}

